import React from 'react';
import Topslider from '../../Components/Homecomp/Calccomp/Topslider'
import Editcomp from '../../Components/Homecomp/Updcomp/Editcomp';
export default function Editpge() {
  return (
    <div>
        
        <Topslider/>
        <br/>
        <br/><br/>
        
        <Editcomp/>
    </div>
  )
}
